// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__f4cjD","mask":"modal_mask__yjB90","content":"modal_content__kCzt-","close_button":"modal_close_button__PleKg"};